<template>
  <div>    
  
    <footer class="bg-gray-100 border-top" >
     
        <div class="container-xl py-40 px-3 px-lg-0">
          <div class="text-center pb-32" v-if="showListMarks">
            <h2 class="h3">Tu cherches une voiture neuve ou d’occasion ?</h2>
            <p>Découvre les offres disponibles sur TopAuto</p>
          </div>
          <div class="text-center pb-32" v-else>
            <h2 class="h3">Les marques automobiles incontournables sur le marché Tunisien</h2>
            <p>Explorez le paysage automobile tunisien avec notre guide des marques leaders</p>
          </div>
          <div
            class="d-flex justify-content-center gap-4 flex-wrap mx-auto"
          >
          <ClientOnly>
            <!--
              Note: Static HTML used due to Nuxt 3 image loading issues
                <nuxt-link
                class="col-5 col-sm-3 col-lg-auto  d-flex flex-column align-items-center justify-content-center"
                v-for="marksLogos  in filteredMarksLogos" 
                :to=" {path : '/voitures/'+marksLogos.name  , query : {MRK : marksLogos.key}}" :key="marksLogos?.name">
                <div class="marks-card" >
                  <NuxtImg :src="`Logo-Marque-Topauto/${marksLogos.name}.svg`"/>
                  <p class="fsz-14">{{ marksLogos.name }}</p>
                </div>
              </nuxt-link> 
          -->
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Audi')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Audi.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Audi</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Chevrolet')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Chevrolet.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Chevrolet</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Ford')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Ford.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Ford</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center d-none d-xxl-block cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Mazda')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Mazda.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Mazda</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Mercedes-Benz')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Mercedes.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Mercedes</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Renault')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Renault.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Renault</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-light"
            @click="navigateToMark('Volkswagen')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-light" src="~/assets/images/Logo-Marque-Topauto/Volkswagen.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Volkswagen</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Ford')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/ford-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Ford</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Renault')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/renault-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Renault</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Skoda')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/skoda-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Skoda</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Volkswagen')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/vw-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Volkswagen</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Audi')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/audi-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Audi</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('BMW')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/bmw-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">BMW</p>
            </div>
          </div>
          <div class="col-5 col-sm-3 col-lg-auto d-flex flex-column align-items-center justify-content-center cursor-pointer marks-item marks-item-dark"
            @click="navigateToMark('Mercedes-Benz')">
            <div class="marks-card">
              <img class="marks-logo marks-logo-dark" src="~/assets/images/Logo-Marque-Topauto/Dark/mercedes-dark.webp" alt="" width="120" height="80" loading="lazy" />
              <p class="fsz-14">Mercedes</p>
            </div>
          </div>
          </ClientOnly>

          </div>
          <ClientOnly>
            <div
            v-if="(width >=breakpoints.screen_tablet) && showListMarks"
            class="nav d-flex gap-2 flex-wrap justify-content-center align-content-center mt-40"
          >
            <div class="nav-item col-lg-3 col-xl-2 m-auto ps-0" v-for="(mark,index) in  searchStore.getMakes?.slice(0 , 40) || []" :key="index">
              <div :key="mark?.name"
                @click="navigateToMark(mark?.name)"
                class="fw-semiBold text-gray-900 fsz-14 d-flex justify-content-start cursor-pointer">
                {{ mark!.name }}
              </div>
            </div>
          </div>
          </ClientOnly>

          <div v-if="width <breakpoints.screen_tablet && showListMarks" class="d-flex justify-content-center mt-32 px-2 px-sm-0" >
            <nuxt-link class="btn btn-solid-primary-600 medium-btn fsz-14 col-12 col-sm-auto" to="/marques-voiture">
              Liste des marques
            </nuxt-link>
          </div>
        </div>
   
 
    </footer>
  </div>

</template>
  
<script setup lang="ts">
import { useSearchStore } from "~/store/useSearchHome";
import { breakpoints } from "~/utils/breakpoints";

const searchStore = useSearchStore();
const { width } = useWindowSize()
const showListMarks = ref();

const activeListMarks = () => {
  const { path } = useRoute()
  if (path == '/marques-voiture') {
    showListMarks.value = false
    return
  }
  showListMarks.value = true
}

const navigateToMark = (mark: string | undefined) => {
  if (mark) {
    window.location.href = `/voitures?makes=${mark}`
  }
}

onMounted(async () => {
  activeListMarks()
  if (!searchStore.getMakes?.length) {
  await searchStore.fetchMarks()
}
})

onUpdated(() => {
  activeListMarks()
});
</script>
  
<style lang="scss" scoped></style>
  
